import cn from 'classnames';

function LdsAccordion({
  accordionId,
  open,
  className,
  children,
  ...rest
}) {
  return (
    <div
      id={accordionId}
      className={cn(
        'lds-accordion',
        {
          open,
        },
        className
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

function Header({ accordionId, open, children }) {
  return (
    <div className="lds-accordion-header" id={`${accordionId}-heading`}>
      <lds-accordion-toggle accordionId={accordionId} aria-controls={`${accordionId}-panel`} isOpen={open}>
        {children}
      </lds-accordion-toggle>
    </div>
  );
}
LdsAccordion.Header = Header;

function Body({ accordionId, children }) {
  return (
    <div className="lds-accordion-body" role="region" aria-labelledby={`${accordionId}-heading`}>
      <div className="lds-accordion-panel" id={`${accordionId}-panel`}>
        {children}
      </div>
    </div>
  );
}
LdsAccordion.Body = Body;

export default LdsAccordion;
